import { showElem, stopElemAnim, addCloseElemAnim, hideElem } from './utils';
import { timeout } from './utils';

const overlayTop = document.querySelector('.overlay-top');

const dropdownHandler = (btn, dropdown, overlay) => {
  btn.addEventListener('mouseenter', () => {
    clearTimeout(timeout.id);

    stopElemAnim(overlay);
    stopElemAnim(dropdown);

    showElem(overlay);
    showElem(dropdown);
  });

  btn.addEventListener('mouseleave', (e) => {
    hideElem(dropdown);
    addCloseElemAnim(overlay);

    timeout.id = setTimeout(() => {
      hideElem(overlay);
    }, 300);
  });

  btn.addEventListener('keydown', (e) => {
    const currentTarget = e.currentTarget;
    const keyCode = e.code;

    if (keyCode === 'Space' || keyCode === 'Enter') {
      if (currentTarget.getAttribute('aria-expanded') === 'true') {
        hideElem(dropdown);
        hideElem(overlay);
        currentTarget.setAttribute('aria-expanded', 'false');
      } else {
        showElem(overlay);
        showElem(dropdown);
        currentTarget.setAttribute('aria-expanded', 'true');
      }
    }
  });

  btn.addEventListener('focusout', (e) => {
    const currentTargetClass = '.' + e.currentTarget.className;

    if (!e.relatedTarget.closest(currentTargetClass)) {
      hideElem(dropdown);
      hideElem(overlay);
      btn.setAttribute('aria-expanded', 'false');
    }
  });
};

export const initDropdown = () => {
  const accountBtn = document.querySelector('.header-account');
  const ctaBtn = document.querySelector('.header-cta');
  const dropdownCTA = document.querySelector('.header-dropdown--cta');
  const dropdownAccount = document.querySelector('.header-dropdown--account');

  dropdownHandler(ctaBtn, dropdownCTA, overlayTop);
  dropdownHandler(accountBtn, dropdownAccount, overlayTop);
};
